export { default } from './available-bank-products';
